export default {
  namespaced: true,
  state: {
    user: {}
  },
  mutations: {

  }
}
